import { useState, type ReactNode } from 'react'
import { EmailVerificationContext, type EmailVerificationContextType } from './emailVerificationContextValue'
import { apiFetch } from '@/lib/apiFetch'
import { getAccessToken } from '@/lib/authToken'

interface EmailVerificationProviderProps {
  children: ReactNode
}

export const EmailVerificationProvider = ({ children }: EmailVerificationProviderProps) => {
  const [showVerificationOverlay, setShowVerificationOverlay] = useState(false)
  const [verificationEmail, setVerificationEmail] = useState('')

  const showVerificationOverlayHandler = (email: string) => {
    setVerificationEmail(email)
    setShowVerificationOverlay(true)
  }

  const hideVerificationOverlay = () => {
    setShowVerificationOverlay(false)
    setVerificationEmail('')
  }

  const checkVerificationStatus = async (): Promise<boolean> => {
    try {
      if (!getAccessToken()) return false
      const response = await apiFetch('/auth/user')
      if (response.ok) {
        const userData = await response.json()
        return userData.isVerified === true
      }
      return false
    } catch (error) {
      console.error('Error checking verification status:', error)
      return false
    }
  }

  const value: EmailVerificationContextType = {
    showVerificationOverlay,
    verificationEmail,
    setVerificationEmail,
    showVerificationOverlayHandler,
    hideVerificationOverlay,
    checkVerificationStatus,
  }

  return (
    <EmailVerificationContext.Provider value={value}>
      {children}
    </EmailVerificationContext.Provider>
  )
}
